import { arrayWithoutSubset, setFulfilled, setPending } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { RecommendedGroupsDismissFulfilledAction } from '../../domains/recommendedGroupDismiss/actions.types';
import type {
  RecommendedGroupsLoadAction,
  RecommendedGroupsLoadFulfilledAction,
} from '../../domains/recommendedGroups/loadActions.types';
import type {
  RecommendedGroupsLoadMoreAction,
  RecommendedGroupsLoadMoreFulfilledAction,
} from '../../domains/recommendedGroups/loadMoreActions.types';

import type { ViewerRecommendedGroupIdSets } from './types';

const loadMoreRecommendedGroupFulfilled = (
  state: ViewerRecommendedGroupIdSets,
  action: RecommendedGroupsLoadMoreFulfilledAction
) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerRecommendedGroupIdSets, dismissedRecommendedGroupIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      recommendedGroupIds: [
        ...new Set([
          ...state.fulfilled.recommendedGroupIds,
          ...arrayWithoutSubset(
            action.payload.entities.viewerRecommendedGroupIdSets.recommendedGroupIds,
            state.fulfilled.dismissedRecommendedGroupIds
          ),
        ]),
      ],
    },
  };
};

const loadRecommendedGroupFulfilled = (
  state: ViewerRecommendedGroupIdSets,
  action: RecommendedGroupsLoadFulfilledAction
) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerRecommendedGroupIdSets, dismissedRecommendedGroupIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      recommendedGroupIds: arrayWithoutSubset(
        action.payload.entities.viewerRecommendedGroupIdSets.recommendedGroupIds,
        state.fulfilled.dismissedRecommendedGroupIds
      ),
    },
  };
};

const dismissRecommendedGroupFulfilled = (
  state: ViewerRecommendedGroupIdSets,
  action: RecommendedGroupsDismissFulfilledAction
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      recommendedGroupIds: state.fulfilled.recommendedGroupIds.filter((id) => id !== action.payload.groupId),
      dismissedRecommendedGroupIds: [...state.fulfilled.dismissedRecommendedGroupIds, action.payload.groupId],
    },
  };
};

export const initialState: ViewerRecommendedGroupIdSets = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type ViewerRecommendedGroupIdSetsAction =
  | RecommendedGroupsLoadAction
  | RecommendedGroupsLoadMoreAction
  | RecommendedGroupsDismissFulfilledAction;

const reducer: Reducer<ViewerRecommendedGroupIdSets, ViewerRecommendedGroupIdSetsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'RECOMMENDED_GROUPS.LOAD_PENDING': {
      if (!state.fulfilled) {
        return setPending();
      }

      return { ...state, fulfilled: { ...state.fulfilled, RecommendedGroupIds: [] } };
    }
    case 'RECOMMENDED_GROUPS.LOAD_FULFILLED':
      return loadRecommendedGroupFulfilled(state, action);
    case 'RECOMMENDED_GROUPS.LOAD_MORE_FULFILLED':
      return loadMoreRecommendedGroupFulfilled(state, action);
    case 'RECOMMENDED_GROUPS.DISMISS_FULFILLED':
      return dismissRecommendedGroupFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
